export const TRANSLATION_PATHS = {
  ROOT: "/i18n/root/",
  SHARED: "/i18n/shared/",
  AUTH: "/i18n/auth/",
  SETTINGS: {
    SYSTEM_SETTINGS: "/i18n/system-settings/",
    SECURITY_SETTINGS: "/i18n/system-settings/",
  },
  AUTHENTICATION: {
    PERMISSION_GROUPS: "/i18n/authentication/permission-groups/",
    ROLES: "/i18n/authentication/roles/",
    USERS: "/i18n/authentication/users/",
    AUDIT_LOGS: "/i18n/authentication/audit-logs/",
    SHARED: "/i18n/authentication/shared/",
  },
  USERS: {
    EMPLOYEES: "/i18n/users/employees/",
    BROKERS: "/i18n/users/brokers/",
    TELECOM_OPERATORS: "/i18n/users/telecom-operators/",
    SHARED: "/i18n/users/shared/",
    MANAGEMENT: "/i18n/users/management/",
  },
  ROLES: {
    MANAGEMENT: "/i18n/roles/management/",
  },
  COMPANY_HIERARCHY: {
    SHARED: "/i18n/company-hierarchy/shared/",
    DIRECTORIES: "/i18n/company-hierarchy/directories/",
    COUNTRIES: "/i18n/company-hierarchy/countries/",
    LANDS: "/i18n/company-hierarchy/lands/",
    AREAS: "/i18n/company-hierarchy/areas/",
    MICRO_AREAS: "/i18n/company-hierarchy/micro-areas/",
    AFFILIATES: "/i18n/company-hierarchy/affiliates/",
    LOCATION_PLACEMENTS: "/i18n/company-hierarchy/location-placements/",
    LOCATIONS: "/i18n/company-hierarchy/locations/",
    OFFICES: "/i18n/company-hierarchy/offices/",
    OFFICE_RULE: "/i18n/company-hierarchy/office-rules/",
  },
  ASSETS: {
    SHARED: "/i18n/assets/shared/",
    CAR_EQUIPMENT_TYPES: "/i18n/assets/car-equipment-types/",
    CAR_EQUIPMENTS: "/i18n/assets/car-equipments/",
    FUEL_CARDS: "/i18n/assets/fuel-cards/",
    POS_DEVICES: "/i18n/assets/pos-devices/",
    DOCUMENT_SCANNERS: "/i18n/assets/document-scanners/",
    DEVICE_TAGS: "/i18n/assets/device-tags/",
    DEVICES: "/i18n/assets/devices/",
    SIM_CARDS: "/i18n/assets/sim-cards/",
    SIGNATURE_LICENSES: "/i18n/assets/signature-licenses/",
    CONSUMABLE_MATERIALS: "/i18n/assets/consumable-materials/",
  },
  CRM: {
    SHARED: "/i18n/crm/shared/",
    DATA_PROCESSING: "/i18n/crm/data-processing/",
    LICENSE_CATEGORIES: "/i18n/crm/license-categories/",
    CRM_SETTINGS: "/i18n/crm/crm-settings/",
    CUSTOMER_DUPLICATION_RULES: "/i18n/crm/customer-duplication-rules/",
    COMPANY_DUPLICATION_RULES: "/i18n/crm/company-duplication-rules/",
    DUPLICATION_SETTINGS: "/i18n/crm/duplication-settings/",
    OPENAPI_SETTINGS: "/i18n/crm/openapi-settings/",
    OTP_SETTINGS: "/i18n/crm/otp-settings/",
    EMAIL_VALIDITY_SETTINGS: "/i18n/crm/email-validity-settings/",
    DOCUMENTS_SETTINGS: "/i18n/crm/documents-settings/",
    DATA_CONVALIDATION_SETTINGS: "/i18n/crm/data-convalidation-settings/",
    BLACKLIST_RULES: "/i18n/crm/blacklist-rules/",
    COMPANIES: "/i18n/crm/companies/",
    CUSTOMERS: "/i18n/crm/customers/",
    DUPLICATION_CLUSTERS: "/i18n/crm/duplication-clusters/",
  },
  DYNAMIC_FORM: {
    DYNAMIC_FORMS: "/i18n/dynamic-form/dynamic-forms/",
    DYNAMIC_FIELDS: "/i18n/dynamic-form/dynamic-fields/",
  },
  FILE_TYPES: "/i18n/file-types/",
  GEO_DATA: {
    SHARED: "/i18n/geo-data/shared/",
    COUNTRIES: "/i18n/geo-data/geo-countries/",
    PROVINCES: "/i18n/geo-data/geo-provinces/",
    CITIES: "/i18n/geo-data/geo-cities/",
    CAPS: "/i18n/geo-data/geo-caps/",
    API_ERRORS: "/i18n/geo-data/api-errors/",
  },
  SCANNED_DOCUMENTS: "/i18n/scanned-documents/",
  SCM: {
    SHARED: "/i18n/scm/shared/",
    SUBJECTS: "/i18n/scm/subjects/",
    SUBJECT_TYPES: "/i18n/scm/subject-types/",
    SUBJECT_STATUSES: "/i18n/scm/subject-statuses/",
    SETTORI_MERCEOLOGICI: "/i18n/scm/settori-merceologici/",
    MAILING_LISTS: "/i18n/scm/mailing-lists/",
    EMAIL_TEMPLATES: "/i18n/scm/email-templates/",
    NOTES: "/i18n/scm/notes/",
    NOTE_SETTINGS: "/i18n/scm/notes/",
    PRATICA_STATUSES: "/i18n/scm/pratica-statuses/",
    PRATICHE: "/i18n/scm/pratiche/",
    SUBJECT_ACTIVITIES: "/i18n/scm/subject-activities/",
    PRACTICE_ACTIVITIES: "/i18n/scm/practice-activities/",
    KPI_DASHBOARD: "/i18n/scm/kpi-dashboard/",
    SPVS: "/i18n/scm/spvs/",
  },
  FLEET: {
    SHARED: "/i18n/fleet/shared/",
    VEHICLE_TYPE: "/i18n/fleet/vehicle-types/",
    FEATURES: "/i18n/fleet/features/",
    FUEL_TYPES: "/i18n/fleet/fuel-types/",
    TIRE_TYPES: "/i18n/fleet/tire-types/",
    TIRE_BRANDS: "/i18n/fleet/tire-brands/",
    CARGO_CATEGORY: "/i18n/fleet/cargo-categories/",
    PARENT_GROUP: "/i18n/fleet/parent-groups/",
    SUPPLY_TYPES: "/i18n/fleet/supply-types/",
    LEASING_TYPES: "/i18n/fleet/leasing-types/",
    PROPERTY_TYPES: "/i18n/fleet/property-types/",
    POST_RENTING_TYPES: "/i18n/fleet/post-renting-types/",
    SUPPLIES: "/i18n/fleet/supplies/",
    GROUP: "/i18n/fleet/groups/",
    FUEL_PRICE_LOGS: "/i18n/fleet/fuel-price-logs/",
  },
} as const;
